<template>
  <div>
    <div class="d-flex align-center">
      <v-text-field
        :label="label || 'Recherchez un membre par numéro de permis'"
        append-icon="mdi-magnify"
        v-model="numeroPermis"
        outlined
        :disabled="updating"
        :loading="updating"
        @click:append="search"
        @keydown.enter="search"
        style="max-width: 400px"
        autocomplete="nope"
        hint="Entrez le numéro de permis complet"
        persistent-hint
      ></v-text-field>
    </div>
    <v-alert text border="left" type="info" v-show="this.errorMessage">{{ this.errorMessage }}</v-alert>
    <v-alert text border="left" type="success" v-show="this.successMessage">{{ this.successMessage }}</v-alert>

    <v-dialog v-model="dialog" width="700">
      <v-card class="pa-6">
        <h2 class="headline mb-3">Résultats</h2>
        <p>Confirmez la sélection du membre</p>
        <v-card
          v-for="membre in result"
          :key="membre.id"
          @click="membreSelected(membre)"
          class="pa-6 mb-3"
          outlined
          max-width="450"
        >
          <h3>{{ membre.nomComplet }}</h3>
          <p class="mb-0"><strong>Numéro de permis:</strong> {{ membre.numeroPermis }}</p>
          <p class="mb-0 caption text--secondary">{{ membre.courriel }}</p>
        </v-card>
        <div class="text-center mt-6">
          <v-btn color="primary" text @click="dialog = false">Annuler</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { Api } from "@/plugins/api"

export default {
  props: {
    label: { type: String, default: "" },
  },
  data() {
    return {
      numeroPermis: "",
      updating: false,
      result: [],
      errorMessage: "",
      successMessage: "",
      dialog: false,
    }
  },
  methods: {
    search() {
      if (!this.numeroPermis || this.numeroPermis.trim().length === 0) {
        this.errorMessage = "Veuillez entrer un numéro de permis"
        return
      }

      this.result = []
      this.errorMessage = ""
      this.successMessage = ""
      this.updating = true

      Api.get("/contacts/search-by-numero-permis?numeroPermis=" + encodeURIComponent(this.numeroPermis.trim()))
        .then((res) => {
          this.result = res.data
          if (this.result.length == 0) {
            this.errorMessage = "Aucun membre trouvé avec ce numéro de permis. Vérifiez le numéro et réessayez."
          } else {
            this.dialog = true
          }
        })
        .catch((err) => {
          this.result = []
          this.errorMessage = err.response?.data?.message || "Erreur lors de la recherche du membre"
        })
        .finally(() => {
          this.updating = false
        })
    },
    membreSelected(membre) {
      this.$emit("membre-selected", { ...membre })
      this.numeroPermis = membre.numeroPermis
      this.successMessage = `Membre sélectionné: ${membre.nomComplet}`
      this.errorMessage = ""
      this.dialog = false

      // Efface le message de succès après 3 secondes
      setTimeout(() => {
        this.successMessage = ""
        this.numeroPermis = ""
      }, 3000)
    },
  },
}
</script>

<style></style>
